// Generated by purs version 0.15.15
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Ouroboros_Models_Brands_AdminUserRole from "../Ouroboros.Models.Brands.AdminUserRole/index.js";
import * as Ouroboros_Models_Brands_Email from "../Ouroboros.Models.Brands.Email/index.js";
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Programs_Controllers_AdminUsers from "../Ouroboros.Programs.Controllers.AdminUsers/index.js";
import * as Ouroboros_Services_Clients_Interop_Option from "../Ouroboros.Services.Clients.Interop.Option/index.js";
var readState = function (v) {
    return v;
};
var readOption = function (v) {
    return v;
};
var matchesEmail = function (email) {
    return function (user) {
        return Data_String_Common.toLower(Ouroboros_Models_Brands_Email.unwrap(user.email)) === Data_String_Common.toLower(email);
    };
};
var isSuperAdminFromRole = /* #__PURE__ */ Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
    return false;
})(function (role) {
    return Ouroboros_Models_Brands_AdminUserRole.unwrap(role) === "SuperAdmin";
});
var buildCurrentRole = function (users) {
    return function (currentEmail) {
        return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
        })(function (email) {
            var v = Data_Array.find(matchesEmail(email))(users);
            if (v instanceof Data_Maybe.Nothing) {
                return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
            };
            if (v instanceof Data_Maybe.Just) {
                return Ouroboros_Services_Clients_Interop_Option.some(v.value0.role);
            };
            throw new Error("Failed pattern match at Ouroboros.Programs.AdminUsersProgram (line 89, column 7 - line 91, column 43): " + [ v.constructor.name ]);
        })(currentEmail);
    };
};
var buildAdminUsersViewProps = function (input) {
    var loadError = readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.loadError));
    var menuUserId = readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.menuUserId));
    var seatLimit = readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.seatLimit));
    var seatsUsed = readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.seatsUsed));
    var users = readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.users));
    var inviteText = readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.inviteText));
    var inviteResult = readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.inviteResult));
    var emailModalValue = readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.emailModalValue));
    var emailModalUser = readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.emailModalUser));
    var emailModalSubmitting = readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.emailModalSubmitting));
    var emailModalError = readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.emailModalError));
    var currentEmail = readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.currentEmail));
    var currentRole = buildCurrentRole(users)(currentEmail);
    var isSuperAdmin = isSuperAdminFromRole(currentRole);
    return {
        users: users,
        inviteText: inviteText,
        inviteResult: inviteResult,
        menuUserId: menuUserId,
        currentEmail: currentEmail,
        loadError: loadError,
        seatsUsed: seatsUsed,
        seatLimit: seatLimit,
        emailModalUser: emailModalUser,
        emailModalValue: emailModalValue,
        emailModalError: emailModalError,
        emailModalSubmitting: emailModalSubmitting,
        pendingEmailValidation: readState(input.kernel.pendingEmailValidation),
        currentRole: currentRole,
        isSuperAdmin: isSuperAdmin,
        onInviteTextChange: Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(input.kernel.inviteText)),
        onInvite: Ouroboros_Programs_Controllers_AdminUsers.onInvite(input.kernel),
        onRefresh: Ouroboros_Programs_Controllers_AdminUsers.onRefresh(input.kernel),
        onMenuUserIdChange: Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetMaybe(input.kernel.menuUserId)),
        onRoleChange: Ouroboros_Programs_Controllers_AdminUsers.onRoleChange(input.kernel),
        onResendInvite: Ouroboros_Programs_Controllers_AdminUsers.onResendInvite(input.kernel),
        onRemovePending: Ouroboros_Programs_Controllers_AdminUsers.onRemovePending(input.kernel),
        onSuspendUser: Ouroboros_Programs_Controllers_AdminUsers.onSuspendUser(input.kernel),
        onReactivateUser: Ouroboros_Programs_Controllers_AdminUsers.onReactivateUser(input.kernel),
        onDeleteUser: Ouroboros_Programs_Controllers_AdminUsers.onDeleteUser(input.kernel),
        onOpenEmailModal: Ouroboros_Programs_Controllers_AdminUsers.onOpenEmailModal(input.kernel),
        onCloseEmailModal: Ouroboros_Programs_Controllers_AdminUsers.onCloseEmailModal(input.kernel),
        onEmailModalValueChange: Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(input.kernel.emailModalValue)),
        onEmailModalSubmit: Ouroboros_Programs_Controllers_AdminUsers.onEmailModalSubmit(input.kernel),
        onInit: Ouroboros_Programs_Controllers_AdminUsers.buildOnInit(input.kernel)
    };
};
export {
    buildAdminUsersViewProps
};
//# sourceMappingURL=index.js.map
